<template>
  <div>
    <b-row class="default-drag-container justify-content-center">
      <b-col :cols="columnsXs"
             :md="columnsMd"
             :lg="columnsLg"
             :sm="columnsSm"
             v-for="(list, index) in lists"
             :key="index"
             class="p-0">
        <div class="default-drag-header">
          <h5 class="text-center mb-0">{{ list.title }}</h5>
        </div>
        <draggable class="list-group default-drag-group pt-3"
                   :class="{
                   'default-drag-group__not-second' : ifNotSecond(index),
                   'default-drag-group__vertical-divider' : index < lists.length - 1
                   }"
                   v-model="list.items"
                   group="people"
                   ghost-class="ghost"
                   @start="list.isDragging = true"
                   @end="list.isDragging = false"
        >
          <div v-for="(item) in list.items" :key="item.id">
              <slot :item="item"></slot>
          </div>
        </draggable>
      </b-col>
    </b-row>
  </div>
</template>


<script>
import {getIndexOfObjectProperty} from "../../utils/object-utils";

export default {
  name: 'DragAndDropField',
  props: {
    lists: {
      type: Object,
      default: []
    },
    title: {
      type: String,
      default: ''
    },
    columnsMd: {
      type: String,
      default: '12'
    },
    columnsLg: {
      type: String,
      default: '12'
    },
    columnsSm: {
      type: String,
      default: '12'
    },
    columnsXs: {
      type: String,
      default: '12'
    }
  },
  data () {
    return {
    }
  },
  methods: {
    ifNotSecond (index) {
      return getIndexOfObjectProperty(this.lists, index) % 2 !== 0
    }
  }
}
</script>
